export const ACTIONS = {
  EDIT: 'edit',
  COPY: 'copy',
  PRINT: 'print',
  DELETE: 'delete',
  VIEW: 'view',
  FIX_IT: 'fix-it',
  REFUND: 'refund',
  RETRY: 'retry',
  SKIP: 'skip',
  DOWNLOAD: 'download',
  INVITE: 'invite',
  SCHEDULEJOB: 'scheduleJob',
  LOCK: 'lock',
  OPEN_INVOICE: 'open-invoice',
  TOOLS: {
    SECTION: 'section',
    FORM: 'form',
    REPORT: 'report',
    DOCUMENT: 'document',
    GRID: 'grid',
  },
  CLICKABLELINK:'clickableLink',
  CONDITIONALTEXTLINK:'conditionalTextLink',
  RADIO:'radio',
  MAPPATIENT:'mapPatient',
  RESEND: 'resend',
  PROCEED: 'proceed',
  SETTLEMENT: 'settlement', // Task/3424 (Refund Authenticator)
};
